module.exports = __webpack_public_path__ + "img/r1.370357fd.jpg";